import Inline from './inline';

export default Inline;
